/** Fired after schedule create / update / complete / cancel / delete so stats + lists refresh. */
export const SCHEDULE_DATA_CHANGED_EVENT = "schedule:data-changed";

export function notifyScheduleDataChanged() {
  if (typeof window !== "undefined") {
    window.dispatchEvent(new CustomEvent(SCHEDULE_DATA_CHANGED_EVENT));
  }
}
